import { IYxInputPropTypes } from "./basePropType";
import PropTypes from "prop-types";

export const IphonePropTypes = {
  ...IYxInputPropTypes,

  //mobile-手机,tel-电话
  type: PropTypes.oneOf(["tel", "mobile"]),
};

export const phoneDefaultProps = () => ({
  inputParam: {},
  type: "mobile", //mobile/tel  手机/电话
  children: "", //子节点
  rules: {},
  styleParam: {
    width: "sm", //宽度  xxs,xs,sm,md,lg,xl
    size: "default", //大小
    type: "default", //类型
  },
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/phonePropType.js